import React, { useEffect, useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom';
import { DELETE, GET } from '../../../helpers/httphelper';
import { ref, deleteObject } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import imgs from '../../../assets/images/no.png';
import { toast as superToast } from 'bulma-toast'

function MedicinesOnesView() {
    // get id from passed props
    const { id } = useParams();
    const [oneMedicine, setOneMedicine] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    console.log(id);
    useEffect(() => {
        const pr = GET(`api/medicine/view/${id}`)
            .then(res => {
                console.log(res);
                setOneMedicine(res);
            }).catch(err => {
                console.log(err);
            });
        Promise.all([pr]).then(() => {
            setIsLoading(false);
        });
    }, [id]);

    console.log(oneMedicine.FileUrl)
    // Delete medicine using delete method
    const deleteMedicine = () => {
        if (oneMedicine.FileUrl !== '') {
            const delRef = ref(storage, oneMedicine.FileUrl);
            deleteObject(delRef).then(() => {
                console.log('Photo Deleted from Storage');
            }).catch((err) => {
                console.log(err);
            });
        }
        DELETE(`api/medicine/delete/${id}`)
            .then(res => {
                console.log(res);
                superToast({
                    message: 'Medicine Deleted Successfully',
                    type: 'is-danger',
                    dismissible: true,
                    position: "top-center",
                    animate: { in: 'fadeIn', out: 'fadeOut' },
                })
                navigate('/medicines');
            }).catch(err => {
                console.log(err);
            });

    }

    return (
        <section className="hero is-fullheight-with-navbar">
            <div className="hero-body">
                <div className="container">
                    {isLoading ?
                        <div className=' has-text-centered'>
                            <div className="">
                                <div className="notification is-success title is-3">
                                    <b> Loading  Medicine... </b>
                                    {/* rotating loading icon from bulma */}
                                    <span className="icon is-large">
                                        <i className="fas fa-sync-alt fa-spin" />
                                    </span>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div >
                                <Link to="/medicines"><h1 className='has-text-left mt-3'><i className="fas fa-arrow-circle-left"></i></h1></Link>
                            </div>
                            <div className="columns">
                                <div className="column is-5">
                                    <div /* className='box' style={{ height: '100%' }} */>
                                        <h1 className="title is-1 is-light is-semibold is-spaced main-title is-justify-content-center is-flex ">  {oneMedicine.MedicineName}</h1>
                                        <figure className="image m-2">
                                            <img style={{ borderRadius: '25px', width: '100%' }} src={oneMedicine?.FileUrl ? oneMedicine.FileUrl : imgs} alt="Medicine Img" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="column is-7">
                                    <div className='box'>
                                        <div className="control">
                                            <div className="input is-hovered has-background-light mt-3">{oneMedicine.MedicineName} </div>
                                            <div className="input is-hovered has-background-light mt-3">{oneMedicine.Dosage} </div>
                                            <div className="input is-hovered has-background-light mt-3">{oneMedicine.Frequency} </div>

                                            {oneMedicine.MedicineTime?.map((time, index) => (
                                                <div key={index}>
                                                    {time.Morning?.map((morinig, k) => (
                                                        <div key={k}>
                                                            <div className='is-flex'>
                                                                <div style={{ alignSelf: 'center' }} className='mr-2'>
                                                                    <label className="checkbox">
                                                                        <div className='input mt-3 is-fullwidth is-flex has-background-light'>
                                                                            <input type="checkbox" disabled defaultChecked={morinig.Morning} className='mr-3' />
                                                                            <span style={{ marginRight: '1.7rem' }}>Morning</span>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                                <div style={{ width: '49%' }}>
                                                                    <div className="input is-hovered has-background-light mt-3">  {morinig.MorningTime} </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {time.Noon?.map((noon, k) => (
                                                        <div key={k}>
                                                            <div className='is-flex'>
                                                                <div style={{ alignSelf: 'center' }} className='mr-2'>
                                                                    <label className="checkbox">
                                                                        <div className='input mt-3 is-fullwidth is-flex has-background-light'>
                                                                            <input type="checkbox" disabled defaultChecked={noon.Noon} className='mr-3' />
                                                                            <span className='mr-6'>Noon</span>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                                <div style={{ width: '49%' }}>
                                                                    <div className="input is-hovered has-background-light mt-3">  {noon.NoonTime} </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {time.Night?.map((night, k) => (
                                                        <div key={k}>
                                                            <div className='is-flex'>
                                                                <div style={{ alignSelf: 'center' }} className='mr-2'>
                                                                    <label className="checkbox">
                                                                        <div className='input mt-3 is-fullwidth is-flex has-background-light'>
                                                                            <input type="checkbox" disabled defaultChecked={night.Night} className='mr-3' />
                                                                            <span className='mr-6'>Night</span>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                                <div style={{ width: '49%' }}>
                                                                    <div className="input is-hovered has-background-light mt-3">  {night.NightTime} </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                            <div className='is-justify-content-space-between is-flex'>
                                                <div style={{ width: '49%' }}>
                                                    <div className="input is-hovered has-background-light mt-3" >{oneMedicine.StartDate}</div>
                                                </div>
                                                <div style={{ width: '49%' }}>
                                                    <div className="input is-hovered has-background-light mt-3" >{oneMedicine.EndDate}</div>
                                                </div>
                                            </div>

                                            <div className="input is-hovered has-background-light mt-3">{oneMedicine?.Channeling}</div>


                                            <textarea defaultValue={oneMedicine.Description} style={{ resize: 'none' }} readOnly className="textarea has-background-light mt-3" placeholder="10 lines of textarea" rows="2"></textarea>
                                        </div>
                                        <div className='is-justify-content-space-evenly is-flex'>
                                            <Link to={"/medicines/update/" + oneMedicine._id}>
                                                <button type='submit'
                                                    style={{ borderRadius: '10px', backgroundColor: '#7BC8FF', fontWeight: '600', color: '#FFFFFF' }}
                                                    className=' button mt-3 pl-5 pr-5 mb-5'
                                                >
                                                    <i className="mr-3 fa-solid fa-gear"></i>
                                                    Update
                                                </button>
                                            </Link>

                                            <button type='submit'
                                                className=' button mt-3 pl-5 pr-5 mb-5'
                                                style={{ borderRadius: '10px', backgroundColor: '#FC370C', fontWeight: '600', color: '#FFFFFF' }}
                                                onClick={() => { if (window.confirm('Are you sure  delete a Medicine ?')) deleteMedicine(oneMedicine._id) }}
                                            >
                                                <i className="mr-3 fa-solid fa-trash"></i>
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
}

export default MedicinesOnesView